import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { Configuration } from '@app/core/config/configuration';
import { ConfigurationService } from '@app/core/config/configuration.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const globalHttpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {

    if (req.url.endsWith('/ping')) {
      return next(req);
    }

    return next(req).pipe(
      catchError((error) => {
        let handled = false;
        console.error(error);
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error('Error Event');
          } else {
            console.log(`error status : ${error.status}`);
            handled = handleError(error.status);
          }
        } else {
          console.error('Other Errors');
        }

        if (handled) {
          console.log('error handled');
          return of(error);
        } else {
          console.log('throw error back to to the subscriber');
          return throwError(() => error);
        }
      })
    );
}

function handleError(status: number): boolean {
  const authenticationService : AuthenticationService = inject(AuthenticationService);
  const router                : Router                = inject(Router);
  const configurationService  : ConfigurationService  = inject(ConfigurationService);
  const config                : Configuration         = configurationService.getConfig();

  switch (status) {
    case 401:
      router.navigateByUrl('/unauthorized');
      console.log('401 - Unauthorized');
      return true;
    case 403: {
      const user = authenticationService.getUser();
      // Wenn der Benutzer undefined ist oder die Inhaltsrolle nicht erhält,
      // wird er auf die Zugriffsantragsseite weitergeleitet
      if (user === undefined) {
        const returnUrl: string = config.rootUrl;
        const ssoClient: string = config.ssoClient;
        globalThis.location.href = config.ssoAccessReqUrl.replace('${ssoClient}', ssoClient).replace('${returnURL}', returnUrl);
        return false;
      }
      router.navigateByUrl('/forbidden');
      console.log('403 - Forbidden');
      return true;
    }
    case 404:
      router.navigateByUrl('/not-found');
      console.log('404 - NotFound');
      return true;
  }
  return false;
}
